export default "__VITE_ASSET__DlLL$d2r__"